module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-nestle-3-fe9f725c96d59bf852060616bdbe2ae7.png";